export default __webpack_public_path__ + "static/rovo-dialect-diagram-light-695c6daea353bcbf14177f1555779257.png";